import { Address } from "../common/geo/address";
import { Phone } from "../common/personal/phone";

export interface Affiliation {
  isAffiliated: boolean;
  details?: AffiliationDetails;
  recognizedEmployerDetails?: RecognizedEmployerAffiliationDetails;
}

export interface AffiliationDetails {
  isDuplicateStatementRequired: boolean;
  relationship: Relationship;
  affiliatedPersonFullName: string;
  company: Company;
}

export interface RecognizedEmployerAffiliationDetails {
  isDuplicateStatementRequired: boolean;
  relationship: Relationship;
  affiliatedPersonFullName: string;
  brokerRecognizedEmployer: BrokerRecognizedEmployer;
}

export interface BrokerRecognizedEmployer {
  employerId: string;
  employerName: string;
}

export const relationships = ["spouse", "parent", "child", "self", "other"] as const;
export type Relationship = typeof relationships[number];

export interface Company {
  name: string;
  phone: Phone;
  email: string;
  address: Address;
}
